import React from 'react';
import {
    Navbar,
    NavbarBrand,
    NavbarToggler,
    Collapse,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import Popover from './components/Popover';

import LogoSistema from '../../components/LogoSistema/LogoSistema';

class Navigation extends React.Component {
    constructor(props) {

        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        return (
            <Navbar expand="lg" className="menu">
                <div className='navigation-menu d-flex justify-content-between align-items-center px-2 w-100'>
                    <NavbarToggler onClick={this.toggle}>
                        <span className="navbar-toggler-bar navbar-hamburg"></span>
                        <span className="navbar-toggler-bar navbar-hamburg"></span>
                        <span className="navbar-toggler-bar navbar-hamburg"></span>
                    </NavbarToggler>
                    <NavbarBrand>
                        <LogoSistema identificacaoLogo={"logotipoBranco"} style={{ maxHeight: '70px' }} />
                        <LogoSistema identificacaoLogo={"logoSecretariaBranco"} className='logoSecretariaNavigation'  style={{ maxHeight:'60px' }} />
                    </NavbarBrand>
                    <span
                        className='titleNavigation p-2'
                        style={{ color: "white", marginTop: "4px", borderLeft: "3px solid white" }}>
                        GESTÃO RESÍDUOS SÓLIDOS ESPECIAIS
                    </span>

                    <Collapse className={`justify-content-end align-items-center ${this.state.isOpen ? "hideCollapse" : "d-flex"}`}>
                        <Nav className="justify-content-center" navbar>
                            <NavItem>
                                <NavLink href="/auth/Opcoes">
                                    Novo Cadastro
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="/auth/MeuCadastro">
                                    Meu Cadastro
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Collapse>
                    {window.location.pathname != "/auth/duvidas" &&
                        <>
                            <div
                                className='navigationDuvidas d-flex justify-content-center align-items-center'
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    background: "transparent",
                                    cursor: "pointer",
                                    margin: ".5rem",
                                    marginRight: "2em"
                                }}
                                id="UncontrolledPopover"
                                type={"button"}
                            >
                                <div style={{ fontSize: "20px", color: "white" }}>
                                    Dúvidas
                                </div>
                            </div>
                            <Popover id={"UncontrolledPopover"} />
                        </>
                    }
                </div>
            </Navbar>
        );
    }
}
export default Navigation;